"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowType = exports.WorkflowObjectObjectEnum = exports.WorkflowListResponseObjectEnum = exports.VisualizationBlockDataDataPeriodAnyOfIntervalEnum = exports.VisualizationBlockDataDataPeriodIntervalEnum = exports.VisualizationBlockDataDataMetricsInnerOneOf1FormatEnum = exports.VisualizationBlockDataDataMetricsInnerOneOf1KindEnum = exports.VisualizationBlockDataDataMetricsInnerOneOfTypeEnum = exports.VisualizationBlockDataDataMetricsInnerOneOfKindEnum = exports.VisualizationBlockDataDataGranularityEnum = exports.VisualizationBlockDataDataTypeEnum = exports.VisualizationBlockDataTypeEnum = exports.UnknownBlockKindEnum = exports.TranscriptItemListResponseObjectEnum = exports.TranscriptItemRoleEnum = exports.ThreadStatus = exports.ThreadObjectObjectEnum = exports.ThreadListResponseObjectEnum = exports.ThreadCreateFormV2PayloadTypeEnum = exports.ThreadCreateFormPayloadTypeEnum = exports.TextBlockKindEnum = exports.StateObjectObjectEnum = exports.StateCreateTaskRequestTypeEnum = exports.StateCreateFormV2RequestTypeEnum = exports.StateCreateFormRequestTypeEnum = exports.SessionObjectObjectEnum = exports.SelectBlockTypeEnum = exports.SelectBlockKindEnum = exports.SectionBlockKindEnum = exports.RealtimeSessionType = exports.RealtimeSessionObjectObjectEnum = exports.RealtimeSessionCreateToolPayloadTypeEnum = exports.RealtimeSessionCreatePayloadModalitiesEnum = exports.MessageRole = exports.MessageObjectObjectEnum = exports.MessageListResponseObjectEnum = exports.LinkObjectObjectEnum = exports.LinkAcceptObjectObjectEnum = exports.InspectionObjectObjectEnum = exports.EventBlockDataOneOfKindEnum = exports.EventBlockKindEnum = exports.CustomBlockKindEnum = exports.CallObjectObjectEnum = exports.ButtonElementVariantEnum = exports.ButtonElementKindEnum = exports.AudioInputBlockKindEnum = exports.ArtifactListResponseResponseObjectEnum = exports.ArtifactListResponseInnerOneOfTypeEnum = exports.ArtifactListResponseInnerOneOfObjectEnum = exports.ActionBlockKindEnum = void 0;
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ActionBlockKindEnum = {
    Action: 'action'
};
exports.ArtifactListResponseInnerOneOfObjectEnum = {
    Artifact: 'artifact'
};
exports.ArtifactListResponseInnerOneOfTypeEnum = {
    Submission: 'submission'
};
exports.ArtifactListResponseResponseObjectEnum = {
    List: 'list'
};
exports.AudioInputBlockKindEnum = {
    AudioInput: 'audio_input'
};
exports.ButtonElementKindEnum = {
    Button: 'button'
};
exports.ButtonElementVariantEnum = {
    Primary: 'primary',
    Secondary: 'secondary'
};
exports.CallObjectObjectEnum = {
    Call: 'call'
};
exports.CustomBlockKindEnum = {
    Custom: 'custom'
};
exports.EventBlockKindEnum = {
    Event: 'event'
};
exports.EventBlockDataOneOfKindEnum = {
    Action: 'action'
};
exports.InspectionObjectObjectEnum = {
    Inspection: 'inspection'
};
exports.LinkAcceptObjectObjectEnum = {
    LinkAccept: 'link_accept'
};
exports.LinkObjectObjectEnum = {
    Link: 'link'
};
exports.MessageListResponseObjectEnum = {
    List: 'list'
};
exports.MessageObjectObjectEnum = {
    Message: 'message'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MessageRole = {
    User: 'user',
    System: 'system'
};
exports.RealtimeSessionCreatePayloadModalitiesEnum = {
    Audio: 'audio',
    Text: 'text'
};
exports.RealtimeSessionCreateToolPayloadTypeEnum = {
    Function: 'function'
};
exports.RealtimeSessionObjectObjectEnum = {
    RealtimeSession: 'realtime_session'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RealtimeSessionType = {
    Realtime: 'realtime'
};
exports.SectionBlockKindEnum = {
    Section: 'section'
};
exports.SelectBlockKindEnum = {
    Input: 'input'
};
exports.SelectBlockTypeEnum = {
    Select: 'select'
};
exports.SessionObjectObjectEnum = {
    Session: 'session'
};
exports.StateCreateFormRequestTypeEnum = {
    Form: 'form'
};
exports.StateCreateFormV2RequestTypeEnum = {
    FormV2: 'form_v2'
};
exports.StateCreateTaskRequestTypeEnum = {
    Task: 'task'
};
exports.StateObjectObjectEnum = {
    State: 'state'
};
exports.TextBlockKindEnum = {
    Text: 'text'
};
exports.ThreadCreateFormPayloadTypeEnum = {
    Form: 'form'
};
exports.ThreadCreateFormV2PayloadTypeEnum = {
    FormV2: 'form_v2'
};
exports.ThreadListResponseObjectEnum = {
    List: 'list'
};
exports.ThreadObjectObjectEnum = {
    Thread: 'thread'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ThreadStatus = {
    Open: 'open',
    Closed: 'closed'
};
exports.TranscriptItemRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
};
exports.TranscriptItemListResponseObjectEnum = {
    List: 'list'
};
exports.UnknownBlockKindEnum = {
    Unknown: 'unknown'
};
exports.VisualizationBlockDataTypeEnum = {
    Visualization: 'visualization'
};
exports.VisualizationBlockDataDataTypeEnum = {
    Trend: 'trend',
    Category: 'category'
};
exports.VisualizationBlockDataDataGranularityEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.VisualizationBlockDataDataMetricsInnerOneOfKindEnum = {
    Aggregation: 'aggregation'
};
exports.VisualizationBlockDataDataMetricsInnerOneOfTypeEnum = {
    Sum: 'sum',
    Average: 'average',
    Distribution: 'distribution',
    Count: 'count'
};
exports.VisualizationBlockDataDataMetricsInnerOneOf1KindEnum = {
    Formula: 'formula'
};
exports.VisualizationBlockDataDataMetricsInnerOneOf1FormatEnum = {
    Currency: 'currency',
    Percentage: 'percentage',
    Integer: 'integer',
    Decimal: 'decimal',
    Time: 'time'
};
exports.VisualizationBlockDataDataPeriodIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.VisualizationBlockDataDataPeriodAnyOfIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.WorkflowListResponseObjectEnum = {
    List: 'list'
};
exports.WorkflowObjectObjectEnum = {
    Workflow: 'workflow'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WorkflowType = {
    Form: 'form',
    Task: 'task',
    FormV2: 'form_v2'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary artifact list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artifactList: async (thread, options = {}) => {
            // verify required parameter 'thread' is not null or undefined
            (0, common_1.assertParamExists)('artifactList', 'thread', thread);
            const localVarPath = `/artifacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary call create
         * @param {CallCreateRequest} [callCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callCreate: async (callCreateRequest, options = {}) => {
            const localVarPath = `/calls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(callCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary inspection create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionCreate: async (threadCreatePayload, options = {}) => {
            const localVarPath = `/inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary link_accept create
         * @param {LinkAcceptCreatePayload} [linkAcceptCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAcceptCreate: async (linkAcceptCreatePayload, options = {}) => {
            const localVarPath = `/links/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linkAcceptCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary link create
         * @param {LinkCreatePayload} [linkCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkCreate: async (linkCreatePayload, options = {}) => {
            const localVarPath = `/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linkCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary message create
         * @param {MessageCreatePayload} [messageCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageCreate: async (messageCreatePayload, options = {}) => {
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(messageCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary message list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList: async (thread, options = {}) => {
            // verify required parameter 'thread' is not null or undefined
            (0, common_1.assertParamExists)('messageList', 'thread', thread);
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary message update
         * @param {string} messageId
         * @param {MessageUpdatePayload} [messageUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageUpdate: async (messageId, messageUpdatePayload, options = {}) => {
            // verify required parameter 'messageId' is not null or undefined
            (0, common_1.assertParamExists)('messageUpdate', 'messageId', messageId);
            const localVarPath = `/messages/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(messageUpdatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary realtime_session create
         * @param {RealtimeSessionCreatePayload} [realtimeSessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtimeSessionCreate: async (realtimeSessionCreatePayload, options = {}) => {
            const localVarPath = `/openai/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(realtimeSessionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary session create
         * @param {SessionCreatePayload} [sessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate: async (sessionCreatePayload, options = {}) => {
            const localVarPath = `/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sessionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary state create
         * @param {StateCreateRequest} [stateCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateCreate: async (stateCreateRequest, options = {}) => {
            const localVarPath = `/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stateCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate: async (threadCreatePayload, options = {}) => {
            const localVarPath = `/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread list
         * @param {ThreadStatus} [status]
         * @param {WorkflowType} [workflow]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadList: async (status, workflow, limit, options = {}) => {
            const localVarPath = `/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (workflow !== undefined) {
                localVarQueryParameter['workflow'] = workflow;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve: async (threadId, options = {}) => {
            // verify required parameter 'threadId' is not null or undefined
            (0, common_1.assertParamExists)('threadRetrieve', 'threadId', threadId);
            const localVarPath = `/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary transcript retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptRetrieve: async (threadId, options = {}) => {
            // verify required parameter 'threadId' is not null or undefined
            (0, common_1.assertParamExists)('transcriptRetrieve', 'threadId', threadId);
            const localVarPath = `/threads/{threadId}/transcript`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary turn retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        turnRetrieve: async (options = {}) => {
            const localVarPath = `/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowList: async (options = {}) => {
            const localVarPath = `/workflows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workflow retrieve
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowRetrieve: async (workflowId, options = {}) => {
            // verify required parameter 'workflowId' is not null or undefined
            (0, common_1.assertParamExists)('workflowRetrieve', 'workflowId', workflowId);
            const localVarPath = `/workflows/{workflowId}`
                .replace(`{${"workflowId"}}`, encodeURIComponent(String(workflowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary artifact list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async artifactList(thread, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.artifactList(thread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.artifactList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary call create
         * @param {CallCreateRequest} [callCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callCreate(callCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callCreate(callCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.callCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary inspection create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionCreate(threadCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionCreate(threadCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.inspectionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary link_accept create
         * @param {LinkAcceptCreatePayload} [linkAcceptCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkAcceptCreate(linkAcceptCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkAcceptCreate(linkAcceptCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.linkAcceptCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary link create
         * @param {LinkCreatePayload} [linkCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkCreate(linkCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkCreate(linkCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.linkCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary message create
         * @param {MessageCreatePayload} [messageCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageCreate(messageCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageCreate(messageCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.messageCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary message list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageList(thread, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageList(thread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.messageList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary message update
         * @param {string} messageId
         * @param {MessageUpdatePayload} [messageUpdatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageUpdate(messageId, messageUpdatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageUpdate(messageId, messageUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.messageUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary realtime_session create
         * @param {RealtimeSessionCreatePayload} [realtimeSessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async realtimeSessionCreate(realtimeSessionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.realtimeSessionCreate(realtimeSessionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.realtimeSessionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary session create
         * @param {SessionCreatePayload} [sessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionCreate(sessionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionCreate(sessionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.sessionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary state create
         * @param {StateCreateRequest} [stateCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stateCreate(stateCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stateCreate(stateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.stateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadCreate(threadCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadCreate(threadCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread list
         * @param {ThreadStatus} [status]
         * @param {WorkflowType} [workflow]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadList(status, workflow, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadList(status, workflow, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadRetrieve(threadId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadRetrieve(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary transcript retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptRetrieve(threadId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptRetrieve(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.transcriptRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary turn retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async turnRetrieve(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.turnRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.turnRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workflowList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workflow retrieve
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowRetrieve(workflowId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowRetrieve(workflowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workflowRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary artifact list
         * @param {DefaultApiArtifactListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artifactList(requestParameters, options) {
            return localVarFp.artifactList(requestParameters.thread, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary call create
         * @param {DefaultApiCallCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callCreate(requestParameters = {}, options) {
            return localVarFp.callCreate(requestParameters.callCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary inspection create
         * @param {DefaultApiInspectionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionCreate(requestParameters = {}, options) {
            return localVarFp.inspectionCreate(requestParameters.threadCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary link_accept create
         * @param {DefaultApiLinkAcceptCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAcceptCreate(requestParameters = {}, options) {
            return localVarFp.linkAcceptCreate(requestParameters.linkAcceptCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary link create
         * @param {DefaultApiLinkCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkCreate(requestParameters = {}, options) {
            return localVarFp.linkCreate(requestParameters.linkCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary message create
         * @param {DefaultApiMessageCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageCreate(requestParameters = {}, options) {
            return localVarFp.messageCreate(requestParameters.messageCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary message list
         * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList(requestParameters, options) {
            return localVarFp.messageList(requestParameters.thread, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary message update
         * @param {DefaultApiMessageUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageUpdate(requestParameters, options) {
            return localVarFp.messageUpdate(requestParameters.messageId, requestParameters.messageUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary realtime_session create
         * @param {DefaultApiRealtimeSessionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtimeSessionCreate(requestParameters = {}, options) {
            return localVarFp.realtimeSessionCreate(requestParameters.realtimeSessionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary session create
         * @param {DefaultApiSessionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate(requestParameters = {}, options) {
            return localVarFp.sessionCreate(requestParameters.sessionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary state create
         * @param {DefaultApiStateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateCreate(requestParameters = {}, options) {
            return localVarFp.stateCreate(requestParameters.stateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread create
         * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate(requestParameters = {}, options) {
            return localVarFp.threadCreate(requestParameters.threadCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread list
         * @param {DefaultApiThreadListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadList(requestParameters = {}, options) {
            return localVarFp.threadList(requestParameters.status, requestParameters.workflow, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread retrieve
         * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve(requestParameters, options) {
            return localVarFp.threadRetrieve(requestParameters.threadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary transcript retrieve
         * @param {DefaultApiTranscriptRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptRetrieve(requestParameters, options) {
            return localVarFp.transcriptRetrieve(requestParameters.threadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary turn retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        turnRetrieve(options) {
            return localVarFp.turnRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowList(options) {
            return localVarFp.workflowList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workflow retrieve
         * @param {DefaultApiWorkflowRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowRetrieve(requestParameters, options) {
            return localVarFp.workflowRetrieve(requestParameters.workflowId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary artifact list
     * @param {DefaultApiArtifactListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    artifactList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).artifactList(requestParameters.thread, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary call create
     * @param {DefaultApiCallCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    callCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).callCreate(requestParameters.callCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary inspection create
     * @param {DefaultApiInspectionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    inspectionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).inspectionCreate(requestParameters.threadCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary link_accept create
     * @param {DefaultApiLinkAcceptCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    linkAcceptCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).linkAcceptCreate(requestParameters.linkAcceptCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary link create
     * @param {DefaultApiLinkCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    linkCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).linkCreate(requestParameters.linkCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary message create
     * @param {DefaultApiMessageCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    messageCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).messageCreate(requestParameters.messageCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary message list
     * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    messageList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).messageList(requestParameters.thread, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary message update
     * @param {DefaultApiMessageUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    messageUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).messageUpdate(requestParameters.messageId, requestParameters.messageUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary realtime_session create
     * @param {DefaultApiRealtimeSessionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    realtimeSessionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).realtimeSessionCreate(requestParameters.realtimeSessionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary session create
     * @param {DefaultApiSessionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sessionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).sessionCreate(requestParameters.sessionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary state create
     * @param {DefaultApiStateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    stateCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).stateCreate(requestParameters.stateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread create
     * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadCreate(requestParameters.threadCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread list
     * @param {DefaultApiThreadListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadList(requestParameters.status, requestParameters.workflow, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread retrieve
     * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadRetrieve(requestParameters.threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary transcript retrieve
     * @param {DefaultApiTranscriptRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    transcriptRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).transcriptRetrieve(requestParameters.threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary turn retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    turnRetrieve(options) {
        return (0, exports.DefaultApiFp)(this.configuration).turnRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workflow list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workflowList(options) {
        return (0, exports.DefaultApiFp)(this.configuration).workflowList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workflow retrieve
     * @param {DefaultApiWorkflowRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workflowRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workflowRetrieve(requestParameters.workflowId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map